<div class="btn-modal-dismiss">
  <button class="btn-no-color d-flex" (click)="close()">
    <ion-icon *ngIf="ThemeService.currentTheme == 'default' " slot="end" src='assets/images/icons-arrow-arrow-left.svg'></ion-icon>
    <ion-icon *ngIf="ThemeService.currentTheme == 'gov' " slot="end" src='assets/images/theme/gov/icons-calendar-arrow-left.svg'></ion-icon>
    <ion-icon *ngIf="ThemeService.currentTheme == 'doneIt' " slot="end" src='assets/images/theme/blue/icons-calendar-arrow-left.svg'></ion-icon> 
  </button>
</div>
